<template>
  <main class="main" :class="{ 'expand-main': isMenuCollapse }">
    <h4>Client Launchings</h4>
    <section>
      <div v-if="loading">
        <LoadingSpinner />
      </div>
      <div v-else>
        <div class="table-responsive mx-0 px-0">
          <Table
            v-if="list.length > 0"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="list"
            :checkbox="false"
            :notselect="true"
            :key="100"
            @goToClient="goToClient"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
import { clientsService } from "@/_services";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      list: [],
      headers: [
        {
          label: "Client Name",
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Client Status",
          percentage: "0.1%",
          class: "overflowhide",
          id: 8,
        },
        {
          label: "Unique prospects",
          percentage: "0.1%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Unique emails",
          percentage: "0.1%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: "Conversion Rate",
          percentage: "0.1%",
          class: "overflowhide",
          id: 7,
        },
        {
          label: "Meetings",
          percentage: "0.1%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: "Assigned booker",
          percentage: "0.1%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Cold Tasks",
          percentage: "0.1%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Days since subscription started",
          percentage: "0.1%",
          class: "overflowhide",
          id: 9,
        },
        {
          label: "Launching status",
          percentage: "0.1%",
          class: "overflowhide",
          id: 10,
        },
      ],
      cols: [
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          {
            value: "client_status",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "active",
                label: "Active",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "Active",
                label: "Active",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "standby",
                label: "Standby",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "Standby",
                label: "Standby",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "deleted",
                label: "Deleted",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "Deleted",
                label: "Deleted",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "preparing",
                label: "Preparing",
                bgColor: "yellow",
                textColor: "#000000",
              },
              {
                id: "Preparing",
                label: "Preparing",
                bgColor: "yellow",
                textColor: "#000000",
              },
            ],
          },
        ],
        [
          {
            value: "total_contacts",
          },
        ],
        [
          {
            value: "emails_sent",
          },
        ],
        [
          {
            value: "conversion_rate",
          },
        ],
        [
          {
            value: "total_meetings",
            type: "itemBadgeConditional",
            format: "genericConditional",
            typeConditional: "equal",
            fieldCondition: "hasBadLaunching",
            valueCondition: "BAD",
            classStyle: "badge badge-danger font-weight-bold"
          },
        ],
        [
          {
            value: "booker_assign",
          },
        ],
        [
          {
            value: "cold_tasks_done",
          },
        ],
        [
          {
            value: "days_since_subscription_started",
          },
        ],
        [
          {
            value: "launching_status",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            tooltipWhenValue: "BAD",
            tooltipText: "+15D < 5meetings",
            colors: [
              {
                id: "BAD",
                label: "BAD",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "OK",
                label: "OK",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
  },
  components: {
    LoadingSpinner,
    Table,
  },
  created() {
    this.getClientLaunchings();
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    setHeader() {
      this.setCurrentRoute({ page: "launching", label: "Launchings" });
      this.setCurrentRouteChild({ child: "" });
    },
    getClientLaunchings() {
      this.loading = true;
      clientsService.getClientLaunchings().then(
        (response) => {
          if (response.status == 200) {
            this.list = response.result;
            this.list.forEach((item) =>{
              item.hasBadLaunching = false;
              if(item.launching_status == 'BAD'){
                item.hasBadLaunching = true;
              }
            })
            this.loading = false;
          }
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    goToClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>

<style></style>
